import { Action, createReducer, on } from '@ngrx/store';
import { ContactSuggesterItem } from '../../models/contact-suggester-item.model';
import { clearRecipients, composeNewEmail } from './actions';

export const EMAILS_SHARED = 'emails.shared';

export interface EmailsSharedState {
  recipients: ContactSuggesterItem[];
}

export const initialState: EmailsSharedState = {
  recipients: []
};

export const reducer = createReducer(
  initialState,
  on(composeNewEmail, (state, { recipients }) => ({
    ...state,
    recipients
  })),
  on(clearRecipients, state => ({
    ...state,
    recipients: []
  }))
);

export function dataReducer(state: EmailsSharedState | undefined, action: Action) {
  return reducer(state, action);
}
